<script setup lang="ts">
const page = usePage<{
  knowledge_base: PublicKBKnowledgeBase
  categories: PublicKBCategory[]
  selected_category?: PublicKBCategory
  selected_article?: PublicKBArticle
}>()
</script>

<template>
  <InertiaHead>
    <title>{{ page.props.knowledge_base.title }}</title>
    <link
      v-if="page.props.knowledge_base.icon_url"
      rel="icon"
      :type="page.props.knowledge_base.icon_type"
      :href="page.props.knowledge_base.icon_url"
    />
  </InertiaHead>

  <div class="group">
    <main class="flex min-h-screen flex-col">
      <PublicKBHeader
        :knowledgeBase="page.props.knowledge_base"
        :compact="page.props.selected_article || page.props.selected_category ? true : false"
      />
      <Container class="flex w-full shrink-0 grow">
        <div class="w-full">
          <slot />
        </div>
      </Container>
      <PublicKBFooter :knowledgeBase="page.props.knowledge_base" class="mt-12" />
    </main>
  </div>
</template>
